// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFilebox24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.50951 5.65753L4.43529 5.81439L1.32757 12.1053C1.27654 12.2086 1.25 12.3223 1.25 12.4375V17.125C1.25 18.5681 2.38467 19.75 3.8 19.75H20.2C21.6153 19.75 22.75 18.5681 22.75 17.125V12.4375C22.75 12.3223 22.7235 12.2086 22.6724 12.1053L19.5494 5.78345C19.1621 4.8695 18.2465 4.24928 17.2295 4.25H6.77C5.81333 4.24932 4.94597 4.79868 4.50951 5.65753ZM6.76947 5.75C6.36127 5.74971 5.9853 6.00438 5.81319 6.40912L5.79543 6.44781L3.42251 11.25H8.4C8.65076 11.25 8.88494 11.3753 9.02404 11.584L10.601 13.949H13.398L14.976 11.584C15.0952 11.4051 15.2843 11.2875 15.4938 11.2576L15.6 11.25H20.577L18.1868 6.40912C18.0319 6.04486 17.7119 5.80215 17.3515 5.75746L17.23 5.75L6.76947 5.75ZM21.25 12.75H16.001L14.424 15.116C14.3048 15.2949 14.1157 15.4125 13.9062 15.4425L13.8 15.45H10.2C9.94923 15.45 9.71506 15.3247 9.57596 15.116L7.998 12.75H2.75V17.125C2.75 17.7112 3.16561 18.1832 3.68681 18.2435L3.8 18.25H20.2C20.7729 18.25 21.25 17.753 21.25 17.125V12.75Z"
				/>
			</Svg>
		);
	}
);
SvgFilebox24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFilebox24;
